export class MipFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getPests(filters) {
    return this.instance.get(`/v1/pests`, {
      params: filters || null,
    });
  }

  getPoints(filters) {
    return this.instance.get(`/v1/mip`, {
      params: filters || null,
    });
  }

  getTotals(filters) {
    return this.instance.get(`/v1/mip/level-count`, {
      params: filters || null,
    });
  }

  getPointsDetails(filters) {
    return this.instance.get(`/v1/mip/details`, {
      params: filters || null,
    });
  }
}

export default MipFactory;
